const SERVER_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss[Z]';

export { SERVER_DATE_FORMAT };
